import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// -------------------- Modal Image Preview --------------------
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.ModalImg.';
  public static readonly modalImg_imagePreview = `${Id.prefix}imagePreview`;
}

export class LangModalImg {
  private constructor() {}
  public static modalImgImagePreview(): string {
    return interpolate(Id.modalImg_imagePreview);
  }
}

export class ModalImgModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.modalImg_imagePreview, 'Image Preview', 'Title for the image preview modal dialog');
  }
}
